import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Divider, Grid, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuiInputField from "../../../../Components/InputField/InputField";
import { checkNumberLimit } from "../../../../Utils/helper";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function PopUpButtons(props) {
  return (
    <Button>
      <Box
        onClick={props.onClick}
        sx={{
          padding: "10px 30px",
          borderRadius: "6px",
          border: "none",
          backgroundColor: props.btnColor,
          textTransform: "capitalize",
        }}
      >
        <Typography
          sx={{
            color: "white",
          }}
        >
          {props.btnName}
        </Typography>
      </Box>
    </Button>
  );
}

function AddNewTpa(props) {
  return (
    <Box
      sx={{
        ...props.style,
        width: 700,
        border: "1px solid lightgray",
        height: 350,
        borderRadius: "15px",
        outline: "none",
        padding: "15px",
      }}
    >
      <Grid container justifyContent="space-between" alignItems={"center"}>
        <Grid>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Add new TPA
          </Typography>
        </Grid>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 25,
            height: 25,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
          />
        </Box>
      </Grid>
      <Grid paddingY={1}>
        <Divider />
      </Grid>
      <Grid
        item
        container
        justifyContent="space-between"
        lg={12}
        paddingX={3}
        paddingY={3}
      >
        <Grid item lg={3}>
          <Typography>TPA Name</Typography>
          <MuiInputField
            type="text"
            value={props?.tpa?.name}
            onChange={(event) => {
              props?.setTPA((s) => ({ ...s, name: event.target.value }));
            }}
            placeHolder={"Add Insurnce name"}
          />
        </Grid>
        <Grid item lg={4}>
          <Typography>Contact Person Name</Typography>
          <MuiInputField
            type="text"
            value={props?.tpa?.contactName}
            onChange={(event) => {
              props?.setTPA((s) => ({
                ...s,
                contactName: event.target.value,
              }));
            }}
            placeHolder={"Add name"}
          />
        </Grid>
        <Grid item lg={4}>
          <Typography>Contact Person Number</Typography>
          <MuiInputField
            type="number"
            value={props?.tpa?.contactNumber}
            onChange={(event) => {
              props?.setTPA((s) => ({
                ...s,
                contactNumber: event.target.value,
              }));
            }}
            placeHolder={"Add Number"}
          />
        </Grid>
      </Grid>
      <Grid
        container
        item
        lg={12}
        height={"80px"}
        justifyContent="flex-end"
        alignItems={"center"}
        sx={{
          gap: "5px",
        }}
      >
        <PopUpButtons
          btnName="Cancel"
          btnColor="grey"
          onClick={() => {
            props.setOpenModal({
              isOpen: false,
            });
          }}
        ></PopUpButtons>
        {props?.tpaId && (
          <PopUpButtons
            btnName="Delete"
            btnColor={"red"}
            onClick={() => {
              props.onDelete();
              props.setOpenModal({
                isOpen: false,
              });
            }}
          ></PopUpButtons>
        )}
        <PopUpButtons
          btnName="Save"
          btnColor="#17dfba"
          onClick={() => {
            props.onSave();
          }}
        ></PopUpButtons>
      </Grid>
    </Box>
  );
}

function AlertPopUp(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  return (
    <Box
      sx={{
        ...style,
        width: 400,
        border: "1px solid lightgray",
        height: 200,
        borderRadius: "15px",
        outline: "none",
        padding: 0,
      }}
    >
      <Grid container justifyContent="flex-end" alignItems={"center"}>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
          />
        </Box>
      </Grid>
      <Grid>
        <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
          {props?.headText}
        </Typography>
      </Grid>
      <Grid
        container
        item
        lg={11.5}
        height={"90px"}
        justifyContent="center"
        alignItems={"center"}
        sx={{ gap: "5px" }}
      >
        {props?.data.buttons.map((item) => {
          return (
            <Button>
              <Box
                onClick={() => {
                  if (item.buttonName === "No") {
                    props?.setOpenModal({ isOpen: false });
                  } else if (item.buttonName == "Yes") {
                    props.handleYes();
                  }
                }}
                sx={{
                  padding: "10px 30px",
                  borderRadius: "6px",
                  border: item.buttonName === "No" ? "1px solid black" : "none",
                  backgroundColor:
                    item.buttonName === "No"
                      ? "#fff"
                      : props.warning
                      ? "red"
                      : "#17dfba",
                  textTransform: "capitalize",
                }}
              >
                <Typography
                  sx={{
                    color: item.buttonName === "No" ? "#000" : "white",
                  }}
                >
                  {item.buttonName}
                </Typography>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Box>
  );
}

export default function AddNewTPA({ setOpenModal, openModal, data }) {
  const handleOpen = () => {
    setOpenModal({ isOpen: true });
  };
  const handleClose = () => {
    setOpenModal({ isOpen: false });
  };
  const [tpa, setTPA] = React.useState({});

  React.useEffect(() => {
    setTPA({
      name: data?.data?.value?.name,
      contactName: data?.data?.value?.contactName,
      contactNumber: data?.data?.value?.contactNumber,
    });
  }, [data]);

  console.log("fjjkldhjohd===============", data?.data);

  return (
    <div style={{ display: "none" }}>
      <Button onClick={handleOpen}>Open modal</Button>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        {data?.data?.type === "TPA" ? (
          <AddNewTpa
            setOpenModal={setOpenModal}
            style={style}
            buttons={data?.data?.buttons}
            tpa={tpa}
            tpaId={data?.data?.tpaId}
            setTPA={setTPA}
            onSave={() => {
              if (tpa.contactNumber && tpa.name) {
                data?.data?.save(
                  {
                    contactName: tpa.contactName,
                    contactNumber: tpa.contactNumber,
                    name: tpa.name,
                  },
                  data?.data?.value?.id
                );
                setOpenModal({
                  isOpen: false,
                });
              } else {
                alert("TPA name and Contact Number are required!");
              }
            }}
            onDelete={() => {
              data?.data?.delete(data?.data?.tpaId);
            }}
          ></AddNewTpa>
        ) : data?.data?.type == "APPROVE" ? (
          <AlertPopUp
            headText={
              data?.data?.checked
                ? "Are you sure want to un approve?"
                : "Are you sure want to approve?"
            }
            setOpenModal={setOpenModal}
            handleYes={() => {
              data?.data?.handleApprove({
                approved: data?.data?.approve,
                id: data?.data?.id,
              });
              console.log("postData", data?.data?.approve, data?.data?.id);
              setOpenModal({ isOpen: false });
            }}
            warning={data?.data?.type == "DELETE"}
            data={data.data}
          />
        ) : (
          <></>
        )}
      </Modal>
    </div>
  );
}
